import { Button, Card, CardContent, Grid } from "@mui/material";
import { makeStyles } from "@mui/styles";
import React, { useEffect, useState } from "react";

import { useSelector } from "react-redux";
import DropdownComponent from "../../../../../App/Components/Dropdown/DropdownComponent";
import Signifier from "../../../../../App/Components/Signifier/Signifier";
import { Roles } from "../../../../../App/Enums/Roles";
import { callAPI } from "../../../../../App/Helpers/callApi";
import { CheckRoleForClient } from "../../../../../App/Helpers/PermissionsChecks";
import { selectCareersClientValue } from "../../../../../App/State/Slices/SelectedCareersClientSlice";
import { selectUserPermissionsValue } from "../../../../../App/State/Slices/UserPermissionsSlice";
import { editMapSearchForm, getMapSearchForm, syncMapSearchFormFromProduction } from "./MapSearchFormService";

function MapSearchFormPage() {
  const useStyles = makeStyles((theme) => ({
    root: {
      width: "50%",
      marginBottom: "50px",
      [theme.breakpoints.down("md")]: {
        width: "100%",
      },
    },
    cardContainer: {
      [theme.breakpoints.down("md")]: {
        width: "100%",
        overflowY: "scroll",
      },
      display: "flex",
      flexDirection: "column",
      marginBottom: "20px",
      width: "100%",
    },
    error: {
      color: theme.palette.error.main,
    },
  }));

  const classes = useStyles();

  const selectCareersClient = useSelector(selectCareersClientValue);
  const rolesObject = useSelector(selectUserPermissionsValue);
  const [showSignifier, setShowSignifier] = useState(false);
  const [responseMessage, setResponseMessage] = useState("");
  const [showError, setShowError] = useState(false);
  const [processing, setProcessing] = useState(false);
  const [loadingSync, setLoadingSync] = useState(false);

  const [templates, setTemplates] = useState([]);
  const [selectedTemplate, setSelectedTemplate] = useState("");

  const [parameters, setParameters] = useState([]);
  const [selectedParameter, setSelectedParameter] = useState("");

  const [keywords, setKeywords] = useState([
    { val: "Yes", id: true },
    { val: "No", id: false },
  ]);
  const [selectedKeyword, setSelectedKeyword] = useState("");

  function getData() {
    getMapSearchForm(selectCareersClient.id).then((response) => {
      response.inputs.forEach((element) => {
        element.display = element.placeholderText + " (" + element.labelText + ")";
        if (response.selectedInput !== null) {
          if (response.selectedInput.availableAdSearchFormInputId === element.availableAdSearchFormInputId) {
            setSelectedParameter(element);
          }
        }
      });
      setSelectedKeyword(response.includeKeyword === false ? keywords[1] : keywords[0]);
      setTemplates(response.templates);
      setParameters(response.inputs);
    });
  }

  function saveMapSearch() {
    let data = {
      ClientId: selectCareersClient.id,
      selectedInput: selectedParameter,
      includeKeyword: selectedKeyword.id,
      templateId: selectedTemplate?.id,
    };

    callAPI(
      editMapSearchForm(selectCareersClient.id, data),
      "Map Search Form Saved",
      setShowSignifier,
      setResponseMessage,
      setShowError,
      setProcessing
    ).then(() => {
      getData();
    });
  }

  function syncSearchForm() {
    if (loadingSync) return;
    setLoadingSync(true);
    callAPI(
      syncMapSearchFormFromProduction(selectCareersClient.id),
      "Map Search Form Synced from Production",
      setShowSignifier,
      setResponseMessage,
      setShowError,
      setProcessing
    )
      .then(() => {
        getData();
      })
      .finally(() => {
        setLoadingSync(false);
      });
  }

  useEffect(() => {
    setTemplates([]);
    setSelectedTemplate("");
    setParameters([]);
    setSelectedParameter("");
    setSelectedKeyword("");
    if (selectCareersClient !== null) {
      getData();
    }
  }, [selectCareersClient]);

  return (
    <>
      <Signifier
        showSignifier={showSignifier}
        setShowSignifier={setShowSignifier}
        message={responseMessage}
        error={showError}
      />
      <div className={classes.root}>
        <Grid className={classes.cardContainer}>
          <Card className={classes.card}>
            <CardContent>
              <Grid container spacing={1}>
                {parameters.length === 0 ? (
                  <span>
                    {" "}
                    The Main Search Form must be configured prior to using this configuration page.
                  </span>
                ) : (
                  <>
                    {CheckRoleForClient(
                      rolesObject,
                      selectCareersClient.id?.toUpperCase(),
                      Roles.SuperAdmin
                    ) ? (
                      <Grid xs={12} sm={12} item>
                        <DropdownComponent
                          emptyRow
                          currValue={selectedTemplate}
                          items={templates}
                          property="name"
                          title="Assign To Template"
                          handleChange={(value) => setSelectedTemplate(value)}
                        />
                      </Grid>
                    ) : null}
                    <Grid xs={12} sm={6} item>
                      <DropdownComponent
                        currValue={selectedKeyword}
                        items={keywords}
                        property="val"
                        title="Include Keyword"
                        handleChange={(value) => setSelectedKeyword(value)}
                      />
                    </Grid>
                    <Grid xs={12} sm={6} item>
                      <DropdownComponent
                        emptyRow
                        currValue={selectedParameter}
                        items={parameters}
                        property="display"
                        title="Additional Parameter"
                        handleChange={(value) => setSelectedParameter(value)}
                      />
                    </Grid>
                    <Grid
                      item
                      xs={12}
                      sm={12}
                      container
                      justifyContent="flex-end"
                      alignItems="flex-end"
                      marginTop="20px"
                      gap={2}
                    >
                      {import.meta.env.VITE_ENV === "Development" && (
                        <Button
                          className={classes.sensitiveButton}
                          type="submit"
                          variant="outlined"
                          color="primary"
                          onClick={() => syncSearchForm()}
                          disabled={loadingSync}
                        >
                          Sync From Production
                        </Button>
                      )}
                      <Button
                        style={{ marginRight: "8px" }}
                        className={classes.sensitiveButton}
                        type="submit"
                        variant="contained"
                        color="primary"
                        onClick={() => saveMapSearch()}
                      >
                        Save Information
                      </Button>
                    </Grid>
                  </>
                )}
              </Grid>
            </CardContent>
          </Card>
        </Grid>
      </div>
    </>
  );
}

export default MapSearchFormPage;
